import DatePeriodPicker from '@/components/common/dateperiodpicker/DatePeriodPicker.vue'

export default {
  name: 'DrnSummaryReports',
  data () {
    return {
      items: null,
      loading: true,
      reportType: 'PACKAGE',
      reportTypeLoaded: 'PACKAGE',
      fromDatePeriod: null,
      toDatePeriod: null,
      currentReq: null,
      isMounted: false,
      merchant: null,
      ldapUserOptions: null,
      downloading: false
    }
  },
  props: {
    activePeriodCode: String
  },
  components: {
    DatePeriodPicker
  },
  computed: {
    reportTypeOptions () {
      const types = ['PACKAGE', 'VKP'];
      const options = [];
      const self = this;
      types.forEach(type => {
        options.push({ value: type, text: self.$t('report-summaries.drn.' + type + '.type-title') });
      });
      return options;
    },
    tableHeaders () {
      return [
        { key: 'number_info', label: this.$t('report-summaries.drn.' + this.reportTypeLoaded + '.number_info') },
        { key: 'title', label: this.$t('report-summaries.drn.' + this.reportTypeLoaded + '.title'), format: 'html' },
        { key: 'total', label: this.$t('report-summaries.drn.' + this.reportTypeLoaded + '.total'), format: 'formatDecimal', precision: 2, class: 'text-center' },
        { key: 'rate', label: this.$t('report-summaries.drn.' + this.reportTypeLoaded + '.rate'), format: 'formatDecimal', precision: 4, class: 'text-center' },
        { key: 'cost', label: this.$t('report-summaries.drn.' + this.reportTypeLoaded + '.cost'), format: 'formatDecimal', precision: 2, class: 'text-center' }
      ]
    }
  },
  methods: {
    getLdapUsers () {
      const self = this;
      this.ApiRequest.request('user/list/0?order=name,asc&isLdapUser=1', this.ApiRequest.REQUEST_GET, [], function (response) {
        if (response.data) {
          self.merchant = response.data.find(el => el.email === 'maris@ecobaltia.lv').api_id;
          self.ldapUserOptions = response.data;
        }
      });
    },
    getSummaryReport () {
      if (this.currentReq) {
        this.currentReq.cancel('changed search query');
      }
      if (this.reportType && this.fromDatePeriod && this.toDatePeriod) {
        const self = this;
        this.loading = true;
        this.currentReq = this.ApiRequest.request('report/drn/summary/' + this.reportType + '/' + this.fromDatePeriod + '/' + this.toDatePeriod, this.ApiRequest.REQUEST_GET, [], function (response) {
          if (response.data) {
            self.items = response.data;
            self.loadedReportType = self.reportType;
          }
          self.loading = false;
        });
      }
    },
    getTableRowClass (item) {
      if (item.rate) {
        return '';
      }
      return ' font-weight-bold';
    },
    getSummaryPdf () {
      this.downloading = true;
      const reqData = {
        merchant: this.merchant
      };
      const self = this;
      this.ApiRequest.request('report/drn/summary-pdf/' + this.reportType + '/' + this.fromDatePeriod + '/' + this.toDatePeriod, this.ApiRequest.REQUEST_DOWNLOAD, reqData, function (response) {
        self.downloading = false;
      });
    }
  },
  mounted () {
    this.fromDatePeriod = this.activePeriodCode;
    this.toDatePeriod = this.activePeriodCode;
    this.isMounted = true;
    this.getLdapUsers();
    this.getSummaryReport();
  }
}
